import { useNavigation } from '@app/hooks/useNavigation';
import { useEffect } from 'react';
import { Layout } from '../Layout/Layout';

export function Download() {
  const { navigation, setNavigation } = useNavigation();

  useEffect(() => {
    if (navigation.scope !== 'dashboardv2') {
      setNavigation((nav) => void (nav.scope = 'dashboardv2'));
    }
  }, [navigation]);

  return (
    <Layout title="Download">
      <p>This is the Download section where users can download documents and resources.</p>
    </Layout>
  );
}
